import { render, staticRenderFns } from "./secondyansheng.vue?vue&type=template&id=6fce4242&scoped=true"
import script from "./secondyansheng.vue?vue&type=script&lang=js"
export * from "./secondyansheng.vue?vue&type=script&lang=js"
import style0 from "./secondyansheng.vue?vue&type=style&index=0&id=6fce4242&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fce4242",
  null
  
)

export default component.exports